import { Inject, Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { from, Observable, throwError } from "rxjs";
import { catchError, tap } from 'rxjs/internal/operators';
import { ActivatedRoute, Router } from "@angular/router";
import { ExternalAuthService } from "./external.auth.service";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private apiBaseUrl: string = '';
    constructor(private _authService: ExternalAuthService, @Inject('environment') environment: any) { 
        this.apiBaseUrl = environment.apiUrl;
    }
intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(!req.url.includes('/auth') && req.url.startsWith(this.apiBaseUrl)){
      return from(
        this._authService.getAccessToken()
        .then(token => {
          const authRequest = req.clone({
            params: (req.params ? req.params : new HttpParams())
                       .set('userId', encodeURIComponent(token.userId)), headers: req.headers.set('Authorization', `Bearer ${token?.token}`)
          } );
          return next.handle(authRequest).toPromise();
        })
      );
    }
    else {
      return next.handle(req);
    }
  }
}
